export default "__VITE_ASSET__a9710e10__"